import { login, logout, getInfo, register, getCaptcha,getMyMessages,updateUserInfo,readMessages,getSalesData,getMySalesData } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    nextorder: '',
    id: 0,
    paymentlink: false,
    searchprice: false,
    NeedPreOrder: false,
    NeedWorkload: false,
    unreadmsgcount: null
  }
}

const state = getDefaultState()

const mutations = {
  SET_ID: (state, id) => {
    state.id = id
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PaymentLink: (state, paymentlink) => {
    state.paymentlink = paymentlink
  },
  SET_SEARCHPRICE: (state, searchprice) => {
    state.searchprice = searchprice
  },
  SET_NEEDPREORDERR: (state, needpreorder) => {
    state.NeedPreOrder = needpreorder
  },
  SET_NEEDWORKLOAD: (state, needworkload) => {
    state.NeedWorkload = needworkload
  },
  SET_UnreadMsgCount: (state, UnreadMsgCount) => {
    if (UnreadMsgCount!==0) {
      state.unreadmsgcount = UnreadMsgCount
    }else {
      state.unreadmsgcount = null
    }
  },
  SET_NEXT_ORDER: (state, nextorder) => {
    state.nextorder = nextorder
  },
  COMPANY_ID: (state, companyid) => {
    state.companyid = companyid
  },
  GROUP_ID: (state, groupid) => {
    state.groupid = groupid
  }
}

const actions = {
  getmysalesdata({ commit },data) {
    return new Promise((resolve, reject) => {
      getMySalesData(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getsalesdata({ commit },params) {
    return new Promise((resolve, reject) => {
      getSalesData(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateuserinfo({ commit },data) {
    return new Promise((resolve, reject) => {
      updateUserInfo(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  readmessage({ commit },params) {
    return new Promise((resolve, reject) => {
      readMessages(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getmymessage({ commit },params) {
    return new Promise((resolve, reject) => {
      getMyMessages(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        // 业务 code 检查
        if (response.code !== 200) {
          return reject(new Error(response.msg || '登录失败'))
        }
        // 数据完整性检查
        const { data } = response
        if (!data || !data.token) {
          return reject(new Error('登录响应异常，请联系管理员'))
        }
        commit('SET_TOKEN', data.token)
        setToken('Bearer ' + data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  register({ commit }, userInfo) {
    const { username, password, nickname, permission, group } = userInfo
    return new Promise((resolve, reject) => {
      register(userInfo).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getcaptcha() {
    return new Promise((resolve, reject) => {
      getCaptcha().then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { user } = response.data
        if (!user) {
          return reject('Verification failed, please Login again.')
        }

        const { NeedPreOrder,NeedWorkload,PaymentLink, NickName, TheNextOrder, CompanyId, RolesList, GroupId, ID,UnreadMsgCount,SearchPirce } = user
        // const roles = RolesList
        // console.log(user)
        // user.Permissions=RolesList
        commit('SET_ROLES', RolesList)
        commit('SET_NAME', NickName)
        commit('SET_NEXT_ORDER', TheNextOrder)
        commit('COMPANY_ID', CompanyId)
        commit('GROUP_ID', GroupId)
        commit('SET_ID', ID)
        commit('SET_PaymentLink', PaymentLink)
        commit('SET_UnreadMsgCount', UnreadMsgCount)
        commit('SET_SEARCHPRICE', SearchPirce)
        commit('SET_NEEDPREORDERR', NeedPreOrder)
        commit('SET_NEEDWORKLOAD', NeedWorkload)
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        dispatch('tagsView/clearAllViews', null, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit, dispatch }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      dispatch('tagsView/clearAllViews', null, { root: true })
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

